import Layout from '@/components/core/Layout';
import CasinoGameList from '@/components/Slots/SlotsCategory/CasinoGameList';
import GameCategoryHeader from '@/components/Slots/SlotsCategory/GameCategoryHeader';
import { Language } from '@/enums/language';
import { GetServerSidePropsResultWithMetadataAndServerState } from '@/interfaces/pages/getServerSidePropsResultWithMetadataAndDehydratedState';
import { generateCasinoMetadata } from '@/lib/metadata';
import { fetchServerSideGameTags } from '@/serverApi/game-tags';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSidePropsContext } from 'next';

export default function GameTagPage() {
  return (
    <Layout disabledGap>
      <GameCategoryHeader />
      <CasinoGameList />
    </Layout>
  );
}

export async function getServerSideProps({
  locale,
  params,
  res,
}: GetServerSidePropsContext): Promise<
  GetServerSidePropsResultWithMetadataAndServerState<{ tag: string }>
> {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=30, stale-while-revalidate=59',
  );
  const queryClient = new QueryClient();
  const gameTags = await fetchServerSideGameTags();

  const selectedTag = gameTags?.find(_tag => _tag?.slug == params?.tag);

  const [metadata] = await Promise.all([
    generateCasinoMetadata({
      lang: locale as Language,
      title: `game-tag:${selectedTag?.id}.name`,
      follow: true,
      path: `/games/tag/${selectedTag?.slug}`,
      description: `game-tag:${selectedTag?.id}.tag_description`,
    }),
    // prefetchGames(queryClient, {} as SSRCookies, {
    //   limit: 50,
    //   query: '',
    //   tag: params?.tag as unknown as GameTagFilter,
    // }),
    // mainPrefetchs({
    //   queryClient,
    //   req,
    // }),
  ]);

  return {
    props: {
      metadata: JSON.stringify(metadata),
      dehydratedState: dehydrate(queryClient),
      tag: params?.tag as string,
    },
  };
}
